<template>
  <form>
    <md-card>
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>group</md-icon>
        </div>
        <h4 class="title">
          Payment Address Details
          <span>
            <i class="fas fa-question-circle question-mark"></i>
            <md-tooltip md-direction="top"
              >This section contains the address associated with your credit
              card / payment method</md-tooltip
            >
          </span>
        </h4>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Address 1</label>
              <md-input
                v-model="card.card.address.line1"
                v-on:input="emitDirty('line1')"
                data-tour="address_1"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Address 2</label>
              <md-input
                v-model="card.card.address.line2"
                v-on:input="emitDirty('line2')"
                data-tour="address_2"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <div class="md-field md-theme-default md-has-value">
              <label>Country</label><br />
              <country-select
                v-model="card.card.address.country"
                :country="card.card.address.country"
                topCountry="CA"
                v-on:input="
                  emitDirty('country');
                  validateBill($v.card.card.address.country);
                "
                data-tour="address_country"
                class="md-input"
              />
            </div>
          </div>
          <div class="md-layout-item md-size-50">
            <div class="md-field md-theme-default md-has-value">
              <label>State/Region</label><br />
              <region-select
                v-model="card.card.address.state"
                :country="card.card.address.country"
                :region="card.card.address.state"
                :regionName="true"
                ref="region-select"
                v-on:input="emitDirty('state')"
                data-tour="address_state"
                class="md-input"
              />
            </div>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>City</label>
              <md-input
                v-model="card.card.address.city"
                v-on:input="emitDirty('city')"
                data-tour="address_city"
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-field>
              <label>Postal Code</label>
              <md-input
                v-model="card.card.address.postalCode"
                v-on:input="emitDirty('postalCode')"
                v-on:blur="validateBill($v.card.card.address.postalCode)"
                data-tour="address_postalcode"
              ></md-input>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import validationRules from "../../validationRules";
export default {
  name: "edit-billing-address-form",
  props: {
    headerColor: {
      type: String,
      default: ""
    },
    card: {},
    ogCard: {},
    questionmark: {
      type: String,
      default: "./img/question_mark_64.png"
    },
    validationTrigger: {}
  },
  watch: {
    validationTrigger: function() {
      if (this.validationTrigger) {
        if (!this.validateBill(this.$v.card.card.address.country)) {
          this.validateBill(this.$v.card.card.address.postalCode);
        }
        this.$emit("validated");
      }
    }
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    validateBill: function(input) {
      input.$touch();
      if (
        !this.$v.card.card.address.country.required ||
        this.$v.card.card.address.country == ""
      ) {
        this.$store.commit("pushError", "Country is required.");
        return true;
      } else if (
        input == this.$v.card.card.address.postalCode &&
        !this.$v.card.card.address.postalCode.isValid
      ) {
        this.$store.commit(
          "pushError",
          "A valid US or Canadian postal code is required."
        );
        return true;
      }
      return false;
    },
    emitDirty: function(p) {
      if (p == "state") {
        // The region selector can race sometimes and cause the region to be empty
        var state = this.$refs["region-select"];
        if (
          this.card.card.address.state == "" &&
          this.card.card.address.state !=
            state.$el[state.$el.selectedIndex].text
        ) {
          setTimeout(() => {
            if (state.$el.selectedIndex > 0) {
              this.card.card.address.state =
                state.$el[state.$el.selectedIndex].text;
              this.emitDirty(p);
            }
          }, 100);
        }
      }
      if (p && this.card.card[p] === "") {
        this.card.card.address[p] = null;
      }
      var dirty = false;
      if (
        this.card.card.address.line1 != this.ogCard.card.address.line1 ||
        this.card.card.address.line2 != this.ogCard.card.address.line2 ||
        this.card.card.address.city != this.ogCard.card.address.city ||
        this.card.card.address.state != this.ogCard.card.address.state ||
        this.card.card.address.postalCode !=
          this.ogCard.card.address.postalCode ||
        this.card.card.address.country != this.ogCard.card.address.country
      ) {
        dirty = true;
      }

      this.$emit("dirty", "address", dirty);
    }
  },
  validations() {
    return validationRules;
  }
};
</script>
<style type="scss" scoped>
select {
  padding: 0 !important;
}
</style>
